// Copyright (c) 2016 Deere & Company

import './index.scss';
import * as PipSearchHelper from '../../shared/services/pip-search-helper';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import {
    injectIntl,
    intlShape
} from 'react-intl';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import OpenPipsFacet from '../../open-pips/state/facets';
import PipProductSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-product';
import PipSearchFacets from './pip-search-facets';
import PipSearchFacetsStruct from '../state/facets';
import PipSearchHeader from './pip-search-header';
import PipSearchList from './pip-search-list';
import PipSearchResult from '@deere/cps-it.warranty-model-factory/lib/pip-search-results';
import PipSearchSearchBox from './pip-search-search-box';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {getExcelLayoutListColumns} from '../services/get-excel-layout-list-columns';
import {getExcelLayoutListId} from '../services/get-excel-layout-list-id';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import {hasAccess} from '../../../shared/services/security';

function handleCreateExcelLayout() {

    const listId = getExcelLayoutListId(this.searchByType);
    const availableColumns = getAllAvailableColumns(listId);

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, listId);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts[listId].length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const listId = getExcelLayoutListId(this.searchByType);
    const availableColumns = getAvailableColumns(listId, this.exportToExcel.selectedExcelLayout[listId].columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout[listId]);
    this.actions.updateExcelLayoutModalIsNewLayout(false, listId);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const listId = getExcelLayoutListId(this.searchByType);
    const availableColumns = getAvailableColumns(listId, selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, listId);
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    const listId = getExcelLayoutListId(this.searchByType);

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout[listId].name, this.exportToExcel.selectedExcelLayout[listId].listId, listId);

}

function handleLayoutNameBlur(layoutName) {

    const listId = getExcelLayoutListId(this.searchByType);

    const nameAlreadyExists = this.exportToExcel.excelLayouts[listId].some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    const listId = getExcelLayoutListId(this.searchByType);

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, listId);

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleExportToExcel(language) {

    const listId = getExcelLayoutListId(this.searchByType);

    const endPoint = PipSearchHelper.mapExcelEndPoints(this.searchQueryString, this.searchByDropDown.selectedOption.key, language, this.exportToExcel.selectedExcelLayout[listId].name);

    exportToExcel(endPoint);

}

class PipSearch extends Component {

    componentWillMount() {

        if (this.props.location.query.q && this.props.location.query.by) {

            this.props.actions.updateSearchQueryString(this.props.location.query.q);
            this.props.actions.updateSearchDropDown(this.props.location.query.by);
            this.props.actions.updateSearchResults(this.props.location.query.q, this.props.location.query.by);
            if (hasAccess(this.props.security, 'PIP', 'PIP_LABOR_ADD_SUMM')) {

                this.props.actions.readLaborAdditivePipsData();

            }
            this.props.actions.readOpenPipsData(this.props.openPipProductsFacets);

        }

    }

    componentWillReceiveProps(nextProps) {

        const newSearch = (nextProps.location.query.by && nextProps.location.query.q) && (this.props.location.query.by !== nextProps.location.query.by || this.props.location.query.q !== nextProps.location.query.q);

        if (newSearch) {

            this.props.actions.updateSearchQueryString(nextProps.location.query.q);
            this.props.actions.updateSearchDropDown(nextProps.location.query.by);
            this.props.actions.updateSearchResults(nextProps.location.query.q, nextProps.location.query.by);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.filteredSearchResults];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, PipSearchHelper.getFilterOptions(this.props.searchByType), sortedCollection);

        const listColumns = getExcelLayoutListColumns(this.props.searchByType);

        const listId = getExcelLayoutListId(this.props.searchByType);

        return (
            <section className='pip-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='aside-container'>
                    <PipSearchFacets/>
                </aside>
                <main className='pip-search-main'>
                    <PipSearchSearchBox/>
                    <PipSearchHeader
                        laborAdditivePipProductsCount={this.props.laborAdditivePipProductsCount}
                        openPipProductsCount={this.props.openPipProductsCount}
                        searchResultsCount={this.props.filteredSearchResults.length}
                    />
                    <section className='pip-results-container'>
                        <RefinableListWidgetWithExportAndLayouts
                            excelLayouts={this.props.exportToExcel.excelLayouts[listId]}
                            hasResults={this.props.filteredSearchResults.length > 0}
                            onCreateLayout={this.props::handleCreateExcelLayout}
                            onEditLayout={this.props::handleEditExcelLayout}
                            onExport={handleExportToExcel.bind(this.props, this.context.user.getLocale())}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onLayoutChange={this.props::handleExcelLayoutChange}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            selectedLayout={this.props.exportToExcel.selectedExcelLayout[listId]}
                            sortOptions={PipSearchHelper.getSortOptions(this.props.searchByType)}
                            type={State}
                        />
                        <PipSearchList
                            busyCounter={this.props.busyCounter}
                            pips={sortedCollection}
                            searchByType={this.props.searchByType}
                        />
                    </section>
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </section>
        );

    }
}
PipSearch.displayName = 'PipSearch';
PipSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.instanceOf(PipSearchFacetsStruct).isRequired,
    filteredSearchResults: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.instanceOf(PipSearchResult),
        PropTypes.instanceOf(PipProductSearchResult)
    ])).isRequired,
    intl: intlShape.isRequired,
    laborAdditivePipProductsCount: PropTypes.number.isRequired,
    location: PropTypes.object,
    openPipProductsCount: PropTypes.number.isRequired,
    openPipProductsFacets: PropTypes.instanceOf(OpenPipsFacet).isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown).isRequired,
    searchByType: PropTypes.string.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResults: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.instanceOf(PipSearchResult),
        PropTypes.instanceOf(PipProductSearchResult)
    ])).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};
PipSearch.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default injectIntl(PipSearch);



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/index.js